module.exports = __webpack_public_path__ + "hinted-Montserrat-Bold.c1614859d5414c03482d.woff";


//////////////////
// WEBPACK FOOTER
// C:/progetti java/ispra-infoaria/ispra-infoaria/ispra-infoaria-wui/infoaria-wui-client/src/assets/custom-styles/fonts/hinted-Montserrat-Bold.woff
// module id = ../../../../../src/assets/custom-styles/fonts/hinted-Montserrat-Bold.woff
// module chunks = 1